export const statusConfig = {
  // Canais
  open: { label: "Conectado", tone: "success" },
  active: { label: "Conectado", tone: "success" },
  Conectado: { label: "Conectado", tone: "success" },
  Desconectado: { label: "Desconectado", tone: "error" },

  // Modelos
  PENDING: { label: "Em análise", tone: "warning" },
  "Em análise": { label: "Em análise", tone: "warning" },
  APPROVED: { label: "Disponível", tone: "success" },
  Disponível: { label: "Disponível", tone: "success" },
  PROCESSING: { label: "Processando", tone: "info" },
  Processando: { label: "Processando", tone: "info" },

  // Operacionais
  pending: { label: "Pendente", tone: "warning" },
  Pending: { label: "Pendente", tone: "warning" },
  Pendente: { label: "Pendente", tone: "warning" },
  Erro: { label: "Falha", tone: "error" },
  ERROR: { label: "Falha", tone: "error" },
  REJECTED: { label: "Falha", tone: "error" },
  rejected: { label: "Falha", tone: "error" },
  Desapproved: { label: "Falha", tone: "error" },
  Reprovado: { label: "Falha", tone: "error" },
  failed: { label: "Falha", tone: "error" },
  falha: { label: "Falha", tone: "error" },
  Falha: { label: "Falha", tone: "error" },

  // Campanhas
  Active: { label: "Ativa", tone: "success" },
  Ativo: { label: "Ativa", tone: "success" },
  Ativa: { label: "Ativa", tone: "success" },
  Desativado: { label: "Desativada", tone: "neutral" },
  Desativada: { label: "Desativada", tone: "neutral" },
  ATIVA: { label: "Em aberto", tone: "warning" },
  Aberta: { label: "Em aberto", tone: "warning" },
  "Em aberto": { label: "Em aberto", tone: "warning" },
  CONCLUIDA: { label: "Concluída", tone: "success" },
  completed: { label: "Concluída", tone: "success" },
  sent: { label: "Concluída", tone: "success" },
  Recebido: { label: "Concluída", tone: "success" },
  Recebida: { label: "Concluída", tone: "success" },
  Concluída: { label: "Concluída", tone: "success" },
  Concluído: { label: "Concluído", tone: "success" },
  Pausado: { label: "Pausada", tone: "warning" },
  Pausada: { label: "Pausada", tone: "warning" },

  // Mensagens e relatórios
  waiting: { label: "Em andamento", tone: "info" },
  running: { label: "Em andamento", tone: "info" },
  "Em andamento": { label: "Em andamento", tone: "info" },
  lida: { label: "Lida", tone: "success" },
  Lida: { label: "Lida", tone: "success" },
  read: { label: "Lida", tone: "success" },
  entregue: { label: "Entregue", tone: "blue" },
  Entregue: { label: "Entregue", tone: "blue" },
  delivered: { label: "Entregue", tone: "blue" },
  espera: { label: "Em espera", tone: "warning" },
  Espera: { label: "Em espera", tone: "warning" },
  "Em espera": { label: "Em espera", tone: "warning" },
  "entrega não confirmada": { label: "Enviada", tone: "neutral" },
  "nao confirmada": { label: "Enviada", tone: "neutral" },
  "não confirmada": { label: "Enviada", tone: "neutral" },
  Enviada: { label: "Enviada", tone: "neutral" },
  "sem whatsapp": { label: "Falha", tone: "error" },

  // Fallbacks controlados
  unknown: { label: "Desconhecido", tone: "neutral" },
  Desconhecido: { label: "Desconhecido", tone: "neutral" },
};

export const fallbackStatus = {
  label: "Desconhecido",
  tone: "neutral",
};

export function resolveStatusBadge(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue) return fallbackStatus;

  return statusConfig[rawValue] || statusConfig[rawValue.toLowerCase()] || fallbackStatus;
}
